import { GET_ERRORS, CREATE_CENTER, UPDATE_CENTER, REFACTOR_CENTER, DELETE_CENTER, UPDATE_CENTER_CONFIGURATION } from '../../../../actions/types';
import { getCentersByPaginator, addCenter, updateCenter, deleteCenter, refactInnerBrachId } from '../../../../actions/CenterActions';
import { updateCenterConfiguration } from '../../../../actions/CenterConfigurationActions';
import CenterConfigurationModalComponent from './CenterConfigurationModalComponent';
import { Info, Build, Delete, Edit, Autorenew } from '@material-ui/icons';
import React, { Component } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { connect } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import { Col, Row } from 'react-bootstrap';

import RefactInnerBranch from './RefactInnerBranch';
import docs from '../../../../config/docs';
import AddCenterModal from './AddCenterModal'

// Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import { IconButton } from 'material-ui';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../MainContent.scss';
import './Center.scss';

// Snack bar
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const URL = docs.docsCenters;

class Center extends Component {
	state = {
		addModalIsVisible: false,
		refacModalIsVisible: false,
		textAreaIsVisible: false,
		activeLoader: true,
		skip: 1,
		limit: 10,
		totalPages: 0,
		modalType: 'NORMAL',
		// dialog
		idCenterToDelete: '',
		showDeleteDialog: false,
		// snack
		showSnackBar: false,
		textSnackBar: '',
		severitySnackBar: 'success',
		centers: []
	};

	constructor(props) {
		super(props);
		this.handleOpenDeleteDialog = this.handleOpenDeleteDialog.bind(this);
		this.handleCloseDeleteDialog = this.handleCloseDeleteDialog.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.openModal = this.openModal.bind(this);
		this.openCenterConfiguration = this.openCenterConfiguration.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
		this.handleUpdateCenterConfiguration = this.handleUpdateCenterConfiguration.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleCancelCenterConfiguration = this.handleCancelCenterConfiguration.bind(this);
		this.handleSubmitRefact = this.handleSubmitRefact.bind(this);
	}

	componentDidMount() {
		this.props.getCentersByPaginator(this.state.skip, this.state.limit);
	}

	componentDidUpdate(prevProps) {
		if (this.state.centers !== this.props.centros) {
			this.setState({
				activeLoader: false,
				totalPages: this.props.totalPages,
				centers: this.props.centros
			});
		}
		else if (this.props.actionType === CREATE_CENTER && prevProps.actionType !== CREATE_CENTER) {
			this.props.getCentersByPaginator(this.state.skip, this.state.limit);
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Centro creado exitosamente.",
				severitySnackBar: "success",
			});
		}
		else if (this.props.actionType === UPDATE_CENTER && prevProps.actionType !== UPDATE_CENTER) {
			this.props.getCentersByPaginator(this.state.skip, this.state.limit);
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Centro actualizado exitosamente.",
				severitySnackBar: "success",
			});
		}
		else if (this.props.actionType === REFACTOR_CENTER && prevProps.actionType !== REFACTOR_CENTER) {
			this.props.getCentersByPaginator(this.state.skip, this.state.limit);
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Centro actualizado exitosamente.",
				severitySnackBar: "success",
			});
		}
		else if (this.props.actionType === DELETE_CENTER && prevProps.actionType !== DELETE_CENTER) {
			this.props.getCentersByPaginator(this.state.skip, this.state.limit);
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Centro desactivado exitosamente.",
				severitySnackBar: "success",
			});
		}
		else if (this.props.actionTypeCenterConfiguration === UPDATE_CENTER_CONFIGURATION && prevProps.actionTypeCenterConfiguration !== UPDATE_CENTER_CONFIGURATION) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Configuración actualizada.",
				severitySnackBar: "success",
			});
		}
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: this.props.error,
				severitySnackBar: 'error',
			});
		}

	}

	///---------------------------------------EVENTS-------------------------------------


	openModal = () => {
		this.setState({
			addModalIsVisible: true,
			modalType: 'NORMAL'
		})
	}

	
	openCenterConfiguration = () => {
		this.setState({
			centerConfigurationModalComponentIsVisible: true
		})
	}

	toogleRefact = () => {
		this.setState({
			refacModalIsVisible: true,
			modalType: 'NORMAL'
		})
	}


	handleUpdate(
		_id,
		nombre,
		clave,
		usoHorario,
		calle,
		numeroExterior,
		numeroInterior,
		colonia,
		codigoPostal,
		municipio,
		estado,
		latitude,
		longitude,
	) {
		this.props.updateCenter(
			_id,
			nombre,
			clave,
			usoHorario,
			calle,
			numeroExterior,
			numeroInterior,
			colonia,
			codigoPostal,
			municipio,
			estado,
			latitude,
			longitude);
		this.setState({
			activeLoader: true,
			addModalIsVisible: false,
			centerData: null
		})
	}

	handleUpdateCenterConfiguration (centerConfiguration) {
		this.props.updateCenterConfiguration(centerConfiguration);
			
		this.setState({
			activeLoader: true,
			centerConfigurationModalComponentIsVisible: false,
			centerData: null
		})
	}

	handleSubmit(nombre,
		clave,
		usoHorario,
		calle,
		numeroExterior,
		numeroInterior,
		colonia,
		codigoPostal,
		municipio,
		estado,
		latitude,
		longitude
	) {
		this.props.addCenter(
			nombre,
			clave,
			usoHorario,
			calle,
			numeroExterior,
			numeroInterior,
			colonia,
			codigoPostal,
			municipio,
			estado,
			latitude,
			longitude
		)
		this.setState({
			activeLoader: true,
			addModalIsVisible: false
		})
	}

	async handleSubmitRefact(old, newClave) {

		this.setState({
			activeLoader: true,
			refacModalIsVisible: false
		})

		this.props.refactInnerBrachId(
			old,
			newClave,
		);
	}

	delay = ms => new Promise(res => setTimeout(res, ms));

	handleCancel() {
		this.setState({
			addModalIsVisible: false,
			refacModalIsVisible: false,
			centerData: null
		})
	}

	handleCancelCenterConfiguration() {
		this.setState({
			centerConfigurationModalComponentIsVisible: false,
			centerData: null
		})
	}
	
	onPageChangeFunction(page, sizePerPage) {
		alert("row", page, sizePerPage)
	}

	onDelete() {
		this.props.deleteCenter(this.state.idCenterToDelete)
		this.setState({
			activeLoader: true,
			showDeleteDialog: false,
			idCenterToDelete: ''
		});
	}

	redirectTo() {
		const newWindow = window.open(URL, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null
	}

	linkActions = (cell, row, rowIndex, formatExtraData) => {
		return ([
			<Row>
				<Col xs={12} md={12} sm={12} lg={12}>
					<IconButton size="small" style={{color:"orange"}}>
						<Edit
							key={row.innerBranchId + 1}
							onClick={() => {
								this.setState({
									modalType: 'UPDATE',
									centerData: row,
									addModalIsVisible: !this.state.addModalIsVisible,
									defaultInnerBranchId: row.innerBranchId
								})
							}}
						>
							Editar
						</Edit>
					</IconButton>
					
					<IconButton size="small" style={{color:"red"}}>
						<Delete
							key={row.innerBranchId + 2}
							onClick={() => {
								this.handleOpenDeleteDialog(row);
							}}
						>
							Eliminar
						</Delete>
					</IconButton>
					
					<IconButton size="small"  style={{color:"blue"}}>
						<Build 
							key={row.innerBranchId + 3}
							onClick={() => {
								this.setState({
									centerData: row,
									centerConfigurationModalComponentIsVisible: !this.state.refacModalIsVisible,
								});
							}}
						/>
					</IconButton>

					<IconButton size="small" style={{color:"orange"}}>
						<Autorenew
							key={row.innerBranchId + 4}
							onClick={() => {
								this.setState({
									modalType: 'UPDATE',
									centerData: row,
									refacModalIsVisible: !this.state.refacModalIsVisible,
									defaultInnerBranchId: row.innerBranchId
								})
							}}
						>
							Cambio de razon social
						</Autorenew>
					</IconButton>
					
				</Col>
			</Row>
			
		]);
	};

	handleOpenDeleteDialog(center) {
		this.setState({
			showDeleteDialog: true,
			idCenterToDelete: center._id,
		});
	}

	handleCloseDeleteDialog() {
		this.setState({
			showDeleteDialog: false,
			idCenterToDelete: ''
		});
	}

	handleCloseSnack = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showSnackBar: false
		})
	}

	///---------------------------------------VIEW-------------------------------------

	render() {
		const customOptions = {
			noDataText: '<div className="color-red">No hay datos disponibles para su consulta.</div>'
		};

		const columns = [
			{
				dataField: 'nombre',
				text: 'Nombre',
				formatter: (cell) => {
					return cell.toUpperCase()
				}
			},
			{
				dataField: 'clave',
				text: 'Clave',
			},
			{
				dataField: 'direccion.estado',
				text: 'Estado'
			},
			{
				dataField: "actions",
				text: "Acciones",
				formatter: this.linkActions,
			}
		];

		return (
			<div className="main-content">
				<div className="malls-category-headers">
					Centros
					<IconButton
						size="small"
					>
						<Info onClick={() => this.redirectTo()} />
					</IconButton>
				</div>
				<div className="auth-label"></div>
				<div className="auth-label"></div>

				<button
					onClick={this.openModal}
					className="btn btn-success"
					style={{ width: "20%", marginTop: "1%", marginRight: "3.5%" }}
				>
					Agregar
				</button>

				<div className="auth-label"></div>
				<div className="auth-label"></div>
				<div className="user-category-wrapper">
					{

						<div>
							<BootstrapTable
								keyField='_id'
								striped
								hover
								condensed
								data={this.state.centers}
								headerWrapperClasses="title-table"
								options={customOptions}
								columns={columns}
							/>
						</div>

					}
					{
						<div className="toolbar100 end">
							<button
								className={this.state.skip !== 1 ? "modalButtonPager" : "modalButtonPager disabled"}
								onMouseDown={(e) => {
									e.preventDefault();
									this.setState({
										activeLoader: true,
										skip: this.state.skip - 1
									}, () => {
										this.props.getCentersByPaginator(this.state.skip, this.state.limit);
									});
								}}
								disabled={this.state.skip === 1 ? true : false}
							>
								« Anterior
							</button>

							<button
								className={this.state.skip < this.state.totalPages ? "modalButtonPager" : "modalButtonPager disabled"}
								onMouseDown={(e) => {
									e.preventDefault();
									this.setState({
										activeLoader: true,
										skip: this.state.skip + 1
									}, () => {
										this.props.getCentersByPaginator(this.state.skip, this.state.limit);
									});
								}}
								disabled={this.state.skip < this.state.totalPages ? false : true}
							>
								Siguiente »
							</button>
						</div>
					}
				</div>

				<LoadingOverlay
					active={this.state.activeLoader}
					isVisible={this.state.activeLoader}
					spinner
					text='Esto puede tardar unos minutos'
					styles={{
						wrapper: {
							width: this.state.activeLoader ? '100%' : '0%',
							height: this.state.activeLoader ? '100%' : '0%',
							overflow: true ? 'hidden' : 'scroll'
						},
						overlay: (base) => ({
							...base,
							background: 'rgba(10, 10, 10, 0.7)'
						})
					}}>
				</LoadingOverlay>
				{
					<AddCenterModal
						isVisible={this.state.addModalIsVisible}
						handleSubmit={this.handleSubmit}
						handleCancel={this.handleCancel}
						centerData={this.state.centerData}
						type={this.state.modalType}
						defaultInnerBranchId={this.state.defaultInnerBranchId}
						handleUpdate={this.handleUpdate}
						onDelete={this.onDelete}
						auth={this.props.auth}
					/>
				}
				{
					<CenterConfigurationModalComponent
						isVisible={this.state.centerConfigurationModalComponentIsVisible}
						centerData={this.state.centerData}
						handleCancel={this.handleCancelCenterConfiguration}
						handleUpdate={this.handleUpdateCenterConfiguration}
					/>
				}
				{
					<RefactInnerBranch
						isVisible={this.state.refacModalIsVisible}
						handleSubmit={this.handleSubmitRefact}
						handleCancel={this.handleCancel}
						centerData={this.state.centerData}
						type={this.state.modalType}
						auth={this.props.auth}
						loaderIsVisible={this.state.loaderIsVisible}
					/>
				}
				{/* Dialog Delete Center*/}
				{
					<Dialog
						open={this.state.showDeleteDialog}
						onClose={this.handleCloseDeleteDialog}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description">
						<DialogTitle id="alert-dialog-title">{"Eliminar Centro"}</DialogTitle>
						<DialogContent id="alert-dialog-description">
							¿Seguro que deseas eliminar el centro?
						</DialogContent>
						<DialogActions>
							<Button onClick={this.handleCloseDeleteDialog} color="secondary">Cancelar</Button>
							<Button onClick={this.onDelete} color="primary">Eliminar</Button>
						</DialogActions>
					</Dialog>
				}
				{/* SNACK BAR */}
				{
					<Snackbar
						open={this.state.showSnackBar}
						autoHideDuration={6000}
						onClose={this.handleCloseSnack}>
						<Alert
							onClose={this.handleCloseSnack}
							severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>)

	}
}

const mapStateToProps = state => ({
	users: state.user_reducer.clients,
	centros: state.center_reducer.centros,
	totalPages: state.center_reducer.totalPages,
	actionType: state.center_reducer.actionType,
	actionTypeCenterConfiguration: state.center_configuration_reducer.actionType,
	error: state.center_reducer.error,
	auth: state.auth
});

export default connect(
	mapStateToProps,
	{
		getCentersByPaginator,
		addCenter,
		updateCenter,
		deleteCenter,
		refactInnerBrachId,
		updateCenterConfiguration
	}
)(Center);
